import React, { useState, useEffect } from "react";
import { Form, Button, Checkbox, Row, Col } from "antd";
import ChildrenAnimationWrapper from "../animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../animations/AnimationChildWrapper";
import { useIntl } from "react-intl";
import moment from "moment";
import { DatePicker } from "../antOverrides";

const { RangePicker } = DatePicker;

const CalenderEventDetails = (props) => {
  const { onChange, activeEvent, onRemove, comp } = props;
  const intl = useIntl();
  const [showDetails, setShowDetails] = useState(false);
  const [form] = Form.useForm();

  // Reset and update form when activeEvent changes
  useEffect(() => {
    if (activeEvent) {
      // Determine if details should be shown based on existing data
      const hasDetails = !!(activeEvent.place || activeEvent.description);
      setShowDetails(hasDetails);

      // Set form values
      form.setFieldsValue(activeEvent);
    } else {
      // Clean up state when no active event
      setShowDetails(false);
      form.resetFields();
    }
  }, [activeEvent, form]);

  // Clean handler for removing event
  const onRemoveEvent = () => {
    form.resetFields();
    setShowDetails(false);
    onRemove();
  };

  // Handle form value changes
  const onValuesChange = (values, all) => {
    const changed = { ...activeEvent, ...all, title: all.place };
    onChange(changed, changed.start, changed.end);
  };

  // Handle time selection changes
  const onTimeChange = (val) => {
    if (val) {
      const changed = {
        ...activeEvent,
        start: val[0].toDate(),
        end: val[1].toDate(),
      };
      onChange(changed, changed.start, changed.end);
    }
  };

  // Toggle details visibility
  const onCheckboxChange = (e) => {
    setShowDetails(e.target.checked);

    // Clear detail fields if hiding details
    if (!e.target.checked) {
      const updatedValues = {
        ...form.getFieldsValue(),
        place: undefined,
        description: undefined,
      };
      form.setFieldsValue(updatedValues);

      // Update parent component
      const changed = { ...activeEvent, ...updatedValues, title: undefined };
      onChange(changed, changed.start, changed.end);
    }
  };

  // Don't render anything if no active event
  if (!activeEvent) return null;

  return (
    <Form
      layout="vertical"
      form={form}
      onValuesChange={onValuesChange}
      style={{ width: "400px" }}
    >
      <ChildrenAnimationWrapper>
        <Row>
          <Col span={24} style={{ padding: "0 20px" }}>
            <AnimationChildWrapper key={1} itemKey={1}>
              <RangePicker
                style={{ width: "100%" }}
                onChange={onTimeChange}
                bordered={true}
                format={"HH:mm"}
                minuteStep={15}
                inputReadOnly={false}
                picker="time"
                value={
                  activeEvent
                    ? [moment(activeEvent["start"]), moment(activeEvent["end"])]
                    : undefined
                }
              />
            </AnimationChildWrapper>

            <AnimationChildWrapper key={2} itemKey={2}>
              <Checkbox
                checked={showDetails}
                onChange={onCheckboxChange}
                style={{ margin: "20px 0" }}
              >
                {intl.formatMessage({
                  id: "app.forms.availability.hasDetails",
                })}
              </Checkbox>
            </AnimationChildWrapper>
            {showDetails ? comp : null}
            <Button block danger onClick={onRemoveEvent}>
              {intl.formatMessage({
                id: "app.actions.delete",
              })}
            </Button>
          </Col>
        </Row>
      </ChildrenAnimationWrapper>
    </Form>
  );
};

export default CalenderEventDetails;
